<template>
<v-app>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex sm8 xs12 md8>
          <div class="text-center display-4">
            <v-layout row justify-center>
              <div id="font">
                Simples
              </div>

              <div id="font" class="primary--text">
                Medic
              </div>
            </v-layout>
          </div>
          <!-- <v-img :src="require('../assets/rect51522.png')" /> -->
          <!-- <img src="../assets/rect51522.png" width="650" class="px-4">         -->
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-card class="elevation-1 rounded-xl">
            <v-card-text>
              <v-form>
                <v-text-field ref="searchLogin" v-model="user.username" prepend-icon="person" name="username" label="Login" type="text" @keyup.enter="logar()" />
                <v-text-field v-model="user.password" prepend-icon="lock" name="password" label="Senha" type="password" @keyup.enter="logar()" />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn :loading="loading" dark class="rounded-xl" color="primary darken-1" @click="logar()">
                Login
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-alert class="mt-2 rounded-xl" dark :value="alert" color="red">
            {{ msg }}
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import Cookies from "js-cookie";
var sha1 = require("sha1");
import commonUserService from "../services/commonUser.service";
import {
  log
} from "util";

export default {
  name: "Login",

  data: () => ({
    user: {
      username: "",
      password: ""
    },
    submitted: false,
    loading: false,
    error: "",
    returnUrl: "",
    usuario: {},
    progress: false,
    alert: false,
    msg: ""
  }),

  mounted() {
    this.isPainel();

    this.$refs.searchLogin.focus();
  },
  methods: {
    isPainel() {
      if (this.$store.getters.usuario.senhaPainel && this.$store.getters.usuario.loginPainel) {
        this.user.username = this.$store.getters.usuario.loginPainel;
        this.user.password = this.$store.getters.usuario.senhaPainel;
        this.logar();
      }
    },

    frontendInicializado() {

    },

      logar() {
  this.loading = true;
  this.alert = false;
  
  // Limpa o timeout anterior se existir
  if (this.loginTimeout) {
    clearTimeout(this.loginTimeout);
  }
  
  // Configura um timeout para evitar loading infinito
  this.loginTimeout = setTimeout(() => {
    this.loading = false;
    this.alert = true;
    this.msg = "Tempo excedido - servidor não respondeu";
  }, 15000);

  if (this.user.username && this.user.password) {
    this.$store.dispatch('updateProntuario', [{idAtendimento: '', conteudoLaudo: '', conteudoProntuario: ''}])
    
    this.$store.dispatch("Login", this.user)
      .then(r => {
        clearTimeout(this.loginTimeout);
        this.loading = false;
        
        // Tratamento para nutricionista
        if (r.perfil && r.perfil === 'nutricionista') {
          return this.$router.push("/homeNutricionista");
        }
        
        // Redirecionamentos por tipo de usuário
        const redirectMap = {
          1: "/dashboardEmpresa",
          2: "/homeRecepcionista",
          3: "/homeAtendente",
          4: "/homeMedico",
          5: "/dashboardUnidade",
          6: () => {
            this.$store.dispatch("SetLoginPainel", this.user.username);
            this.$store.dispatch("SetSenhaPainel", this.user.password);
            return "/HomePainel";
          },
          7: "/homeApoio",
          8: "/homeMedico",
          10: "/homeAdministradorDev",
          11: "/homeRecepcionistaEspecial",
          12: "/posAtendimento",
          13: "/homeNutricionista"
        };
        
        const redirectTo = redirectMap[r.tipo];
        if (typeof redirectTo === 'function') {
          this.$router.push(redirectTo());
        } else if (redirectTo) {
          this.$router.push(redirectTo);
        } else {
          this.alert = true;
          this.msg = "Tipo de usuário não reconhecido";
        }
      })
      .catch(error => {
        clearTimeout(this.loginTimeout);
        this.loading = false;
        this.alert = true;
        // Exibe a mensagem de erro retornada pelo servidor
        this.msg = error.message || error || "Erro desconhecido ao fazer login";
      });
  } else {
    clearTimeout(this.loginTimeout);
    this.loading = false;
    this.alert = true;
    this.msg = "Por favor, preencha todos os campos";
  }
}
  },

  props: {
    source: String
  }
};
</script>

<style scoped>
@font-face {
  font-family: "organo";
  src: url("../assets/Organo.ttf");
}

.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}

#font {
  font-family: 'organo';
}
</style>
